module.exports = __webpack_public_path__ + "img/_serbia.9a139a61.png";